/* eslint-disable vue/valid-v-bind */
<template>
  <div>
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        data-aos="fade"
        data-aos-duration="2000"
        id="feature4"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        {{ $t('title') }}
      </h3>
      <p
        data-aos="fade"
        data-aos-delay="800"
        data-aos-duration="2000"
        class="mdc-typography--body text-color font-weight-bold"
      >
        {{ $t('subtitle') }}
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          v-for="item in items"
          :key="item.id"
          data-aos="fade"
          data-aos-delay="0"
          data-aos-duration="2000"
          v-bind:class="'place-cell--' + item.city"
          class="mdc-layout-grid__cell place-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content--place pane-content pb-1 px-5 d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color always-white">
              {{ item.city }}
            </h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold always-white"
            >
              {{ item.typeofcity }}
            </p>
            <p
              class="mdc-typography--subtitle2 city-info text-color mt-auto mx-auto"
            >
              {{ item.details }}
            </p>
            <!-- <img src="/img/maps/medgidia.jpg" alt /> -->
          </div>
          <!-- END CARD CONTENT -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Maps',
  el: '#example-1',
  data: function() {
    return {
      items: [
        {
          city: this.$t('city1.name'),
          typeofcity: this.$t('city1.typeofcity'),
          details: this.$t('city1.details')
        },
        {
          city: this.$t('city2.name'),
          typeofcity: this.$t('city2.typeofcity'),
          details: this.$t('city2.details')
        },
        {
          city: this.$t('city3.name'),
          typeofcity: this.$t('city3.typeofcity'),
          details: this.$t('city3.details')
        },
        {
          city: this.$t('city4.name'),
          typeofcity: this.$t('city4.typeofcity'),
          details: this.$t('city4.details')
        },
        {
          city: this.$t('city5.name'),
          typeofcity: this.$t('city5.typeofcity'),
          details: this.$t('city5.details')
        },
        {
          city: this.$t('city6.name'),
          typeofcity: this.$t('city6.typeofcity'),
          details: this.$t('city6.details')
        },
        {
          city: this.$t('city7.name'),
          typeofcity: this.$t('city7.typeofcity'),
          details: this.$t('city7.details')
        },
        {
          city: this.$t('city8.name'),
          typeofcity: this.$t('city8.typeofcity'),
          details: this.$t('city8.details')
        }
      ]
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Maps",
    "subtitle": "Places allow you to see where your friends are, to discover new places, opportunities and people.",
    "city1": {
      "name": "Medgidia",
      "typeofcity": "City",
      "details": "💼 42 new active jobs"
    },
    "city2": {
      "name": "Constanța",
      "typeofcity": "City",
      "details": "18 of your friends have moved here"
    },
    "city3": {
      "name": "București",
      "typeofcity": "Capital",
      "details": "33 startups joined"
    },
    "city4": {
      "name": "Cluj",
      "typeofcity": "City",
      "details": "155 active investors"
    },
    "city5": {
      "name": "Sibiu",
      "typeofcity": "City",
      "details": "You have 22 friends here"
    },
    "city6": {
      "name": "Brașov",
      "typeofcity": "City",
      "details": "150 designers joined"
    },
    "city7": {
      "name": "Iași",
      "typeofcity": "Capital",
      "details": "24 companies hire"
    },
    "city8": {
      "name": "Timișoara",
      "typeofcity": "City",
      "details": "8 active universities"
    }
  },
  "ro": {
    "title": "Hărți",
    "subtitle": "Locurile îţi permit să vezi unde sunt prietenii tăi să descoperi locuri, oportunități și oameni noi.",
    "city1": {
      "name": "Medgidia",
      "typeofcity": "Oraș",
      "details": "💼 42 de joburi noi active"
    },
    "city2": {
      "name": "Constanța",
      "typeofcity": "Oraș",
      "details": "18 din prietenii tăi s-au mutat aici"
    },
    "city3": {
      "name": "București",
      "typeofcity": "Capitală",
      "details": "33 de startup-uri s-au alăturat"
    },
    "city4": {
      "name": "Cluj",
      "typeofcity": "Oraș",
      "details": "155 de investitori activi"
    },
    "city5": {
      "name": "Sibiu",
      "typeofcity": "Oraș",
      "details": "Ai 22 de prieteni aici"
    },
    "city6": {
      "name": "Brașov",
      "typeofcity": "Oraș",
      "details": "150 de designeri s-au alăturat"
    },
    "city7": {
      "name": "Iași",
      "typeofcity": "Oraș",
      "details": "24 de companii angajează"
    },
    "city8": {
      "name": "Timișoara",
      "typeofcity": "Oraș",
      "details": "8 universități"
    }
  }
}
</i18n>

<style>
.city-info {
  width: 100%;
  text-align: center;
  padding: 12px;
  border-radius: 4px;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  background-color: var(--city-notification-bg) !important;
}
.grid-cell-400 {
  background: var(--grid-cell);
  height: 40vh;
  min-height: 400px;
}
.card-content--place {
  background: rgba(0, 0, 0, 0.24);
}
.place-cell {
  min-height: 300px !important;
  height: 376px !important;
}
.place-cell--Medgidia {
  background-image: url(/img/maps/medgidia.jpg);
  background-position: center;
  background-size: cover;
}
.place-cell--Constanța {
  background-image: url(/img/maps/constanta.jpg);
  background-position: center;
  background-size: cover;
}
.place-cell--București {
  background-image: url(/img/maps/bucuresti.jpg);
  background-position: right;
  background-size: cover;
}
.place-cell--Cluj {
  background-image: url(/img/maps/cluj.jpg);
  background-position: center;
  background-size: cover;
}
.place-cell--Sibiu {
  background-image: url(/img/maps/sibiu.jpg);
  background-position: center;
  background-size: cover;
}
.place-cell--Brașov {
  background-image: url(/img/maps/brasov.jpg);
  background-position: center;
  background-size: cover;
}
.place-cell--Iași {
  background-image: url(/img/maps/iasi.jpg);
  background-position: right;
  background-size: cover;
}
.place-cell--Timișoara {
  background-image: url(/img/maps/timisoara.jpg);
  background-position: center;
  background-size: cover;
}
</style>
